module.exports = __webpack_public_path__ + "static/media/4H.578341b1.svg";